import React from "react";

const ProjectsPage = () => {
  return <div></div>;
};

export default ProjectsPage;
